<template>
  <div>
    <div class="details_content_repeat">
      <QS-scroller-box>
        <QS-h4-title title="退车信息" />
        <form-text-box
          :column="2"
          :dataList="dataList"
          :rules="configRules"
          :model="configDefaultValue"
          ref="returnInfo"
        />
        <template slot="bottomAction">
          <el-button @click="goPageBack" size="mini">取消退车</el-button>
          <el-button
            :loading="submitLoading"
            type="primary"
            size="mini"
            @click="submitHandle"
          >发起退车</el-button>
        </template>
      </QS-scroller-box>
    </div>
  </div>
</template>
<script>
import { initiateVehicle } from '@/api/purchaseAndSaleAPI'
import selectOptionDict from '@/store/dict/selectOptionDict'
import { checkOrderNeedRefund } from '@/api/domain/returnLease'

export default {
  name: 'vehiclesettlements',
  data() {
    return {
      submitLoading: false,
      configDefaultValue: {
        receivableDeposit: '', // 应收押金
        closeType: '', // 退车类型
        closeReason: '', // 退车原因
      },
      configRules: {
        closeType: [
          { required: true, message: '请选择退车类型', trigger: 'change' },
        ],
        closeReason: [
          { required: true, message: '退车原因不能为空', trigger: 'change' },
        ],
      },
      // 表单配置项
      dataList: [
        {
          el: 'text',
          itemConfig: {
            label: '应收押金',
            prop: 'receivableDeposit',
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '退车类型',
            prop: 'closeType',
          },
          elConfig: {
            options: {
              label: 'name',
              value: 'id',
              list: selectOptionDict.returnTypeToBeConfirmed,
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '退车原因',
            prop: 'closeReason',
            type: 'textarea',
          },
          elConfig: {
            type: 'textarea',
            maxlength: 50,
            showWordLimit: true,

          },
        },
      ],
    }
  },
  inject: ['orderData'],
  watch: {
    orderData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && val.orderId) {
          this.configDefaultValue.receivableDeposit = `${
            this.numberWithCommas(val.totalDeposit) || '0.00'
          } / ${this.numberWithCommas(val.receivedDeposit) || '0.00'}`
        }
      },
    },
  },
  methods: {
    async searchHandle(params) {
      const { id } = this.$route.query
      this.submitLoading = true
      try {
        const { code, data } = await initiateVehicle({
          orderId: id,
          closeType: Number(params.closeType),
          closeReason: params.closeReason,
        })
        if (code === 1 && data) {
          this.$message({
            message: '退车成功',
            type: 'success',
          })
          this.goPageBack(true)
        }
        this.submitLoading = false
      } catch (error) {
        this.submitLoading = false
      }
    },
    submitHandle() {
      this.$refs.returnInfo.getRefs().validate((validate) => {
        if (validate) {
          // 判断是否要弹退钱的弹窗
          this.checkOrderNeedToRefund()
        }
      })
    },
    // 返回上一级
    goPageBack(status = false) {
      this.$refreshBack(status) // 关闭当前tab
    },
    // 字典数据返回数组下拉框
    filterDictArray(dict) {
      const result = []
      for (const key in dict) {
        result.push({ name: dict[key], id: key })
      }
      return result
    },
    // 判断是否有金额退款，司机已支付且签约完成但未发车
    async checkOrderNeedToRefund() {
      if (this.orderData.state === 1500) {
        const { data } = await checkOrderNeedRefund({
          orderId: this.orderData.id,
        })
        if (data) {
          this.$confirm('发起退车后，将原路退还司机已线上支付的全部金额。是否继续？', '发起退车', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            this.searchHandle(this.configDefaultValue)
          }).catch(() => null)
        } else {
          this.searchHandle(this.configDefaultValue)
        }
      } else {
        this.searchHandle(this.configDefaultValue)
      }
    },
  },
  mounted() {
    const { state } = this.$route.query
    // 0:待确认 1500:发车待验车 2500:履约中
    if (Number(state) === 0 || Number(state) === 1000 || Number(state) === 1500) {
      // 待确认、待出库
      this.dataList.forEach((item) => {
        if (item.itemConfig.prop === 'closeType') {
          const result = this.filterDictArray(selectOptionDict.returnTypeToBeConfirmed)
          this.$refs.returnInfo.setItemData({ elConfigKey: 'list', key: 'closeType', data: result })
        }
      })
    } else if (Number(state) === 2500) {
      // 履约中
      this.dataList.forEach((item) => {
        if (item.itemConfig.prop === 'closeType') {
          const result = this.filterDictArray(selectOptionDict.closingReasonInPerformance)
          this.$refs.returnInfo.setItemData({ elConfigKey: 'list', key: 'closeType', data: result })
        }
      })
    }
  },
}
</script>

